import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";

Vue.use(Router);
Vue.use(VueCroppie);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "base",
      component: () => import("../views/Home.vue"),
      props: {},
    },

    {
      path: "/admin",
      name: "admin",
      component: () => import("../views/adminroute.vue"),
      props: { forms: store.state.forms },
    },
    {
      path: "/guide",
      name: "guide",
      component: () => import("../views/pluginGuide.vue"),
      props: { forms: store.state.forms },
    },
    {
      path: "/newform",
      name: "newform",
      component: () => import("../views/newformroute.vue"),
      props: { payload: store.state.newformroute },
    },
    {
      path: "/form/:formid/:formpos",
      name: "viewform",
      component: () => import("../views/fillformroute.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/admin/editform/:formno",
      name: "editform",
      component: () => import("../views/editformroute.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/admin/category_form/:formno",
      name: "category_form",
      component: () => import("../views/editformroute.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/admin/:formno",
      name: "editform",
      component: () => import("../views/editformroute.vue"),
      props: { payload: store.state.currentForm },
    },

    {
      path: "/fill",
      name: "fill",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/fillformroute.vue"),
    },

    {
      path: "/edit",
      name: "edit",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/editformroute.vue"),
    },
    {
      path: "/admin/viewform/:formno",
      name: "viewforms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/ViewForms.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/whatsappwidget",
      name: "whatsappwidget",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/whatsappwidget.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/editform/:formno",
      name: "editforms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/editformfromViewform.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/admin/additemstoform/:formno",
      name: "addItems",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/addItemsToForm.vue"),
      props: { payload: store.state.currentForm },
    },
    {
      path: "/orderManagement",
      name: "orderManagement",
      component: () => import("../views/orderManagement.vue"),
      props: { forms: store.state.forms },
    },
  ],
});
